import * as actionTypes from '../constants/userActionTypes';
import * as api from '../api';
import { toast } from "react-toastify";

/**
* function for Activity schedule
* @param {*} data User data 
* @description get user infromation
* @param {function} getActivityScheduleList getActivityScheduleList function
*/
export const getProjectList = () => async dispatch => {
    try {
        dispatch({ type: actionTypes.GET_PROJECT_REQUEST })
        const { data } = await api.getProjectsList();
        dispatch({ type: actionTypes.GET_PROJECT_SUCCESS, payload: data })
    } catch (err) {
        dispatch({ type: actionTypes.GET_PROJECT_FAIL, payload: err.response.data })
    }
}

export const getProjectsListForAddPartner = () => async dispatch => {
    try {
        dispatch({ type: actionTypes.GET_PROJECT_REQUEST })
        const { data } = await api.getProjectsListForAddPartner();
        dispatch({ type: actionTypes.GET_PROJECT_SUCCESS, payload: data })
    } catch (err) {
        dispatch({ type: actionTypes.GET_PROJECT_FAIL, payload: err.response.data })
    }
}
/**
* function for Activity schedule
* @param {*} data User data 
* @description get user infromation
* @param {function} getProjectStatusList getProjectStatusList function
*/
export const getProjectStatusList = () => async dispatch => {
    try {
        dispatch({ type: actionTypes.GET_PROJECT_STATUS_REQUEST })
        const { data } = await api.getProjectsStatus();
        dispatch({ type: actionTypes.GET_PROJECT_STATUS_SUCCESS, payload: data })
    } catch (err) {
        dispatch({ type: actionTypes.GET_PROJECT_STATUS_FAIL, payload: err.response.data })
    }
}

export const createProjectDetail = (projectDetail, history) => async dispatch => {
    try {
        dispatch({ type: actionTypes.CREATE_PROJECT_REQUEST })
        const { data } = await api.createProjectDetail(projectDetail);
        toast.success(data.message);
        dispatch({ type: actionTypes.CREATE_PROJECT_SUCCESS, payload: data })
        history.push('/activity-schedule')
    } catch (err) {
        console.log(err)
        toast.error(err?.response?.data.message);
        dispatch({ type: actionTypes.CREATE_PROJECT_FAIL, payload: err.response.data })
    }
}

export const getCampaignList = (id = '') => async dispatch => {
    try {
        dispatch({ type: actionTypes.GET_CAMPAIGN_REQUEST })
        const { data } = await api.getCampaignList(id);
        dispatch({ type: actionTypes.GET_CAMPAIGN_SUCCESS, payload: data })
    } catch (err) {
        dispatch({ type: actionTypes.GET_CAMPAIGN_FAIL, payload: err.response.data })
    }
}



export const getProjectFilter = (searchInput = '', partner = '', search_date = '', status = '') => async dispatch => {
    try {
        dispatch({ type: actionTypes.GET_PROJECT_REQUEST })
        const { data } = await api.getProjectsList(searchInput, partner, search_date, status);
        dispatch({ type: actionTypes.GET_PROJECT_SUCCESS, payload: data })
    } catch (err) {
        dispatch({ type: actionTypes.GET_PROJECT_FAIL, payload: err.response.data })
    }
}

/**
* function for editProject
* @param {*} data User data 
* @description get user infromation
* @param {function} editProject editProject function
*/
export const editProject = (id) => async dispatch => {
    try {
        dispatch({ type: actionTypes.EDIT_PROJECT_REQUEST })
        const { data } = await api.editProject(id);
        dispatch({ type: actionTypes.EDIT_PROJECT_SUCCESS, payload: data })
    } catch (err) {
        dispatch({ type: actionTypes.EDIT_PROJECT_FAIL, payload: err.response.data })
    }
}
/**
* function for editProject
* @param {*} data User data 
* @description get user infromation
* @param {function} editProject editProject function
*/
export const updateProject = (formData) => async dispatch => {
    try {
        dispatch({ type: actionTypes.EDIT_PROJECT_REQUEST })
        const { data } = await api.updateProject(formData);
        toast.success(data.message)
        dispatch({ type: actionTypes.EDIT_PROJECT_SUCCESS, payload: data })
    } catch (err) {
        toast.error(err?.response?.data.message);
        dispatch({ type: actionTypes.EDIT_PROJECT_FAIL, payload: err.response.data })
    }
}

/**
* function for update Project Related Campaigns
* @param {*} data User data 
* @description get user infromation
* @param {function} updateProjectRelated Campaigns updateProjectRelated Campaigns function
*/
export const updateProjectRelatedCampaigns = (formData) => async dispatch => {
    try {
        dispatch({ type: actionTypes.EDIT_PROJECT_REQUEST })
        const { data } = await api.updateRelatedCampaignsProject(formData);
        toast.success(data.message)
        dispatch({ type: actionTypes.EDIT_PROJECT_SUCCESS, payload: data })
    } catch (err) {
        dispatch({ type: actionTypes.EDIT_PROJECT_FAIL, payload: err.response.data })
    }
}

export const getProjectScheduleDetail = (id) => async dispatch => {
    try {
        dispatch({ type: actionTypes.GET_PROJECT_SCHEDULE_REQUEST })
        const { data } = await api.getProjectScheduleDetail(id);
        dispatch({ type: actionTypes.GET_PROJECT_SCHEDULE_SUCCESS, payload: data })
    } catch (err) {
        dispatch({ type: actionTypes.GET_PROJECT_SCHEDULE_FAIL, payload: err.response.data })
    }
}

export const resendInviteEmailonMember = (id) => async dispatch => {
    try {
       // dispatch({ type: actionTypes.RESEND_INVITE_MEMBER_REQUEST })
        const { data } = await api.resendInviteEmailMember(id);
        toast.success(data.message);
        //dispatch({ type: actionTypes.RESEND_INVITE_MEMBER_SUCCESS, payload: data })
    } catch (err) {
        toast.error(err.response.data.message)
        //dispatch({ type: actionTypes.RESEND_INVITE_MEMBER_FAIL, payload: err.response.data })
    }
}

/**
* function for project members
* @param {*} data User data 
* @description get user infromation
* @param {function} getProjectMember getProjectMember function
*/
export const getProjectMembers = (id) => async dispatch => {
    try {
        dispatch({ type: actionTypes.GET_PROJECT_MEMBER_REQUEST })
        const { data } = await api.getProjectsMembers(id);
        dispatch({ type: actionTypes.GET_PROJECT_MEMBER_SUCCESS, payload: data })
    } catch (err) {
        dispatch({ type: actionTypes.GET_PROJECT_MEMBER_FAIL, payload: err.response.data })
    }
}
/**
* function for project Objective Types
* @param {*} data Objective Types data 
* @description get Objective Types infromation
* @param {function} getObjectiveTypes getObjectiveTypes function
*/
export const getObjectiveTypes = () => async dispatch => {
    try {
        dispatch({ type: actionTypes.PROJECT_OBJECTIVE_TYPES_REQUEST })
        const { data } = await api.getObjectiveType();
        dispatch({ type: actionTypes.PROJECT_OBJECTIVE_TYPES_SUCCESS, payload: data })
    } catch (err) {
        dispatch({ type: actionTypes.PROJECT_OBJECTIVE_TYPES_FAIL, payload: err.response.data })
    }
}
/**
* function for project Audience Type
* @param {*} data Audience Type data 
* @description get Audience Type infromation
* @param {function} AudienceType Audience Type function
*/
export const getAudienceTypes = () => async dispatch => {
    try {
        dispatch({ type: actionTypes.PROJECT_AUDIENCE_TYPES_REQUEST })
        const { data } = await api.getAudienceType();
        dispatch({ type: actionTypes.PROJECT_AUDIENCE_TYPES_SUCCESS, payload: data })
    } catch (err) {
        dispatch({ type: actionTypes.PROJECT_AUDIENCE_TYPES_FAIL, payload: err.response.data })
    }
}

/**
* function for project Supporting Docs
* @param {*} data Supporting Docs data 
* @description get Supporting Docs infromation
* @param {function} getProjectSupportingDocuments Supporting Docs function
*/
export const getProjectSupportingDocuments = (project ,searchInput = '') => async dispatch => {
    try {
        dispatch({ type: actionTypes.GET_PROJECT_SUPPORTING_DOCS_REQUEST })
        const { data } = await api.getProjectsSupportingDocumentsList(project, searchInput);
        dispatch({ type: actionTypes.GET_PROJECT_SUPPORTING_DOCS_SUCCESS, payload: data })
    } catch (err) {
        dispatch({ type: actionTypes.GET_PROJECT_SUPPORTING_DOCS_FAIL, payload: err.response.data })
    }
}

/**
* function for project Timeline
* @param {*} data Timeline data 
* @description get Timeline infromation
* @param {function} getProjectTimelins Timeline function
*/
export const getProjectTimelins = (projectId) => async dispatch => {
    try {
        dispatch({ type: actionTypes.GET_PROJECT_TIMELINES_REQUEST })
        const { data } = await api.getProjectTimelines(projectId);
        dispatch({ type: actionTypes.GET_PROJECT_TIMELINES_SUCCESS, payload: data })
    } catch (err) {
        dispatch({ type: actionTypes.GET_PROJECT_TIMELINES_FAIL, payload: err.response.data })
    }
}


/**
* function for project limit
* @param {*} data project limit data 
* @description get limit infromation
* @param {function} checkUserEmail limit function
*/
export const checkUserEmail = (email) => async dispatch => {
    try {
        dispatch({ type: actionTypes.CHECK_USER_BY_EMAIL_REQUEST })
        const { data } = await api.apiCurrentPartner(email);
        dispatch({ type: actionTypes.CHECK_USER_BY_EMAIL_SUCCESS, payload: data })
    } catch (err) {
        dispatch({ type: actionTypes.CHECK_USER_BY_EMAIL_FAIL, payload: err.response.data })
    }
}

export const checkJobNumberUnique = async (jobNumber) => {
    try {
    const { data } = await api.apiCheckJobNumber(jobNumber);
      return data;
    } catch (error) {
      console.log("error", error);
      return error;
    }
};


/**
* function for project limit
* @param {*} data project limit data 
* @description get limit infromation
* @param {function} getProjectLimits limit function
*/
export const getAllProjectsApprovers = (id) => async dispatch => {
    try {
        dispatch({ type: actionTypes.GET_PROJECT_APPROVERS_REQUEST })
        const { data } = await api.getProjectApproverList(id);
        dispatch({ type: actionTypes.GET_PROJECT_APPROVERS_SUCCESS, payload: data })
    } catch (err) {
        dispatch({ type: actionTypes.GET_PROJECT_APPROVERS_FAIL, payload: err.response.data })
    }
}